// src/components/forms/modals/Ancillary/AncillaryDialog.tsx
import React from "react";
import ConnectionFormDialog from "../../forms/ConnectionFormDialog";
import FormSelectField from "../../forms/fields/basic/SelectField";
import { AncillaryConnection } from "../../../types/ancillary";
import { SystemEntityCollections } from "../../../shared/enums/shared-enums";
import renderWorkSelection from "../../entitiesReferences/SelectionModals/WorkSelectionModal";
import { Work } from "../../../types/work";
import { ConnectionFormDataController } from "../../../controllers/formController";
import useAncillaryLogic from "../../../hooks/logic/connections/ancillaryLogic";

interface AncillaryDialogProps {
  controller: ConnectionFormDataController<AncillaryConnection, Work, Work>;
  systemLanguageType: Work["system_language_type"];
}

const AncillaryDialog: React.FC<AncillaryDialogProps> = ({
  controller,
  systemLanguageType,
}) => {
  const { workAncillaryEnum } = useAncillaryLogic(
    controller.from,
    controller.to
  );
  return (
    <ConnectionFormDialog<AncillaryConnection, Work, Work>
      fromLabel="Work"
      toLabel="Work"
      fromEntityCollection={SystemEntityCollections.WORK}
      toEntityCollection={SystemEntityCollections.WORK}
      renderFromEntitySelection={renderWorkSelection(systemLanguageType)}
      renderToEntitySelection={renderWorkSelection(systemLanguageType)}
      controller={controller}
    >
      <FormSelectField
        name="work_ancillary_type"
        label="Ancillary Type"
        placeholder="Select ancillary type"
        required
        useEnum={workAncillaryEnum}
      />
    </ConnectionFormDialog>
  );
};

export default AncillaryDialog;
